import { render, staticRenderFns } from "./Cardiologies.vue?vue&type=template&id=b24c7efc&scoped=true"
import script from "./Cardiologies.vue?vue&type=script&lang=js"
export * from "./Cardiologies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24c7efc",
  null
  
)

export default component.exports